module.exports = __webpack_public_path__ + "static/media/arrow_down.193356c0.svg";